import styled from "styled-components";
import { StyledHomePageSectionBlock } from "../../home/styledHomePage";

export const StyledFooterWrapper = styled.footer`
  padding: 50px 0 80px;
  color: #333333;
  background: linear-gradient(195deg, rgba(250, 250, 250, 0.9) -3%, transparent 115%);
  a {
    color: #333333;
    transition: all .3s ease;
    &:hover {
      color: #C1B2D7;
    }
  }
  
  @media screen and (max-width: 768px) {
    padding: 50px 0;
  }
  @media screen and (max-width: 576px) {
    padding: 30px 0;
  }
`;

export const StyledFooterContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
  display: grid;
  grid-template-areas: "logo nav"
                        "social nav"
                        "social nav"
                        "social nav"
                        "doc doc";
  justify-content: space-between;
  position: relative;
  @media screen and (min-width: 992px) {
    &:before {
      content: "";
      width: 495px;
      height: 495px;
      position: absolute;
      top: -260px;
      left: -280px;
      background: rgba(155, 104, 228, 0.2);
      filter: blur(100px);
      user-select: none;
    }
  }
  @media screen and (max-width: 576px) {
    &:before {
      filter: blur(50px);
    }
  }
  .footer-nav {
    grid-area: nav;
    display: grid;
    grid-template-columns: repeat(3, max-content);
    grid-gap: 75px;
  }
  .footer-doc {
    width: 100%;
    padding-top: 140px;
    grid-area: doc;
    display: flex;
    justify-content: space-between;
  }
  
  @media screen and (max-width: 768px) {
    grid-template-columns: 100%;
    grid-template-areas: "logo"
                         "nav"
                         "social"
                         "doc";
    .footer-nav {
      margin-bottom: 30px;
      justify-content: space-between;
      grid-gap: 15px;
    }
    .footer-doc {
      padding-top: 10px;
      flex-direction: column;
    }
  }
`;

export const StyledFooterLogo = styled.div`
  margin-bottom: 10px;
  grid-area: logo;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  z-index: 10;
  
  @media screen and (max-width: 768px) {
    margin-bottom: 35px;
  }
  @media screen and (max-width: 576px) {
    margin-bottom: 25px;
    font-size: 15px;
  }
`;

export const StyledSocialWrapper = styled.div`
  max-width: 260px;
  grid-area: social;
  z-index: 10;
  ul {
    margin-bottom: 15px;
    display: grid;
    grid-template-columns: repeat(3, max-content);
    grid-gap: 15px;
    a {
      width: 20px;
      height: 20px;
      display: inline-flex;
      justify-content: center;
      font-size: 20px;
    }
  }
  
  @media screen and (max-width: 768px) {
    ul {
      margin-bottom: 20px;
    }
  }
  @media screen and (max-width: 576px) {
    max-width: 225px;
    p {
      font-size: 10px;
    }
  }
`;

export const StyledFooterBlockItem = styled.div``;

export const StyledFooterBlockItemTitle = styled.div`
  padding-bottom: 25px;
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  @media screen and (max-width: 576px) {
    padding-bottom: 12px;
    font-size: 12px;
  }
`;

export const StyledFooterBlockItemList = styled.ul`
  li {
    padding-top: 7px;
    &:not(:last-child) {
      padding-bottom: 7px;
    }
    @media screen and (max-width: 576px) {
      padding-top: 4px;
      font-size: 11px;
      &:not(:last-child) {
        padding-bottom: 4px;
      }
    }
  }
`;

export const StyledFooterAuthor = styled.div`
  font-size: 11px;
`;

export const StyledFooterDocuments = styled.ul`
  font-size: 11px;
  display: grid;
  grid-template-columns: repeat(3, max-content);
  grid-gap: 40px;
  li {
    position: relative;
    &:not(:last-child):after {
      content: "|";
      position: absolute;
      top: 0;
      right: -20px;
    }
  }
  
  @media screen and (max-width: 768px) {
    margin: 25px auto 0;
  }
  @media screen and (max-width: 576px) {
    font-size: 10px;
    grid-gap: 35px;
    &:not(:last-child):after {
      right: 17.5px;
    }
  }
`;